// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6500":"aaa2a638e0138341","8603":"eabf44f4a7bb323c"}[chunkId] + ".css";
};